import { motion } from "framer-motion";

// Slow editorial infinite marquee ribbon.
const words = [
  "Custom Design",
  "Heirloom Craft",
  "25+ Years of Experience",
  "You Dream — We Create",
  "Family Owned",
  "Ethical Stones",
  "Bench-Made in House",
  "Exclusive Designs",
];

export default function Marquee() {
  const track = [...words, ...words];
  return (
    <section
      aria-hidden="true"
      className="relative bg-[#E5D5C1] border-y border-[#1C1C1A]/15 py-8 overflow-hidden"
    >
      <div className="flex w-max animate-marquee">
        {track.map((w, i) => (
          <div
            key={i}
            className="flex items-center gap-10 pr-10 font-serif text-[#1C1C1A] text-4xl md:text-6xl leading-none"
          >
            <motion.span
              whileHover={{ letterSpacing: "0.06em" }}
              transition={{ duration: 0.6 }}
              className="italic font-light"
            >
              {w}
            </motion.span>
            <span className="text-[#9A8B73]">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
